import './form-quote-transport.scss';

import { QuoteTransportFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = QuoteTransportFormSchema;
export function FormQuoteTransport() {
  const { control } = useFormContext<QuoteTransportFormSchema>();
  return (
    <div id="FormQuoteTransport" className="quote-transport">
      <InputControl<InputFormSchema>
        control={control}
        name="quotation"
        label="Quotation"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter quotation"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="transportType"
        label="Transport Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter transportType"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="fromLocation"
        label="From Location"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter fromLocation"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="toLocation"
        label="To Location"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter toLocation"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="pricePerPax"
        label="Price Per Pax"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter pricePerPax"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="numPeople"
        label="Num People"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter numPeople"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="unit"
        label="Unit"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter unit"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
    </div>
  );
}

export default FormQuoteTransport;